var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "navbar navbar-expand-lg portal-navbar" }, [
    _vm.entorno
      ? _c("span", { staticClass: "entorno-badge" }, [
          _vm._v(" " + _vm._s(_vm.nombreEntorno) + " "),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "navbar-minimize col-auto pe-0" }, [
            _c(
              "button",
              {
                staticClass: "boton-icono d-none d-lg-flex",
                attrs: {
                  type: "button",
                  "aria-label": "Plegar o desplegar el menú",
                  title: "Plegar o desplegar el menú",
                },
                on: { click: _vm.abrirSideBar },
              },
              [
                _c("i", {
                  class: _vm.$sidebar.isMinimized
                    ? "fa fa-ellipsis-v"
                    : "fa fa-navicon",
                }),
              ]
            ),
          ]),
          _vm._m(0),
        ]),
        _c(
          "button",
          {
            staticClass: "navbar-toggler navbar-toggler-right",
            class: { toggled: _vm.$sidebar.showSidebar },
            attrs: { type: "button", "aria-expanded": "false" },
            on: { click: _vm.toggleSidebar },
          },
          [
            _c("span", { staticClass: "navbar-toggler-bar burger-lines" }),
            _c("span", { staticClass: "navbar-toggler-bar burger-lines" }),
            _c("span", { staticClass: "navbar-toggler-bar burger-lines" }),
          ]
        ),
        _c(
          "div",
          { staticClass: "btn-group dropstart align-items-center me-lg-2" },
          [
            _vm.isAgrupacion
              ? _c(
                  "el-select",
                  {
                    staticClass: "portal-header-franquicia ms-1",
                    attrs: {
                      placeholder: "Franquicia",
                      size: "small",
                      filterable: "",
                    },
                    on: { change: _vm.franquiciaChange },
                    model: {
                      value: _vm.franquiciaSelected,
                      callback: function ($$v) {
                        _vm.franquiciaSelected = $$v
                      },
                      expression: "franquiciaSelected",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-home el-input__icon",
                      attrs: { slot: "prefix", "aria-hidden": "true" },
                      slot: "prefix",
                    }),
                    _vm._l(_vm.franquicias, function (item) {
                      return _c("el-option", {
                        key: item._id,
                        attrs: {
                          label: item.codigo + " " + item.nombre,
                          value: item._id,
                        },
                      })
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _c("NotificationsMenu", { staticClass: "ms-2" }),
            _c("span", {
              staticClass: "portal-header-separator mx-3",
              attrs: { "aria-hidden": "true" },
            }),
            _c(
              "button",
              {
                staticClass: "avatar-usuario portal-header-action",
                attrs: {
                  type: "button",
                  "data-bs-toggle": "dropdown",
                  "data-bs-display": "static",
                  "aria-expanded": "false",
                  "aria-label": "Mi cuenta",
                },
              },
              [_vm._v(" " + _vm._s(_vm.iniciales) + " ")]
            ),
            _c(
              "ul",
              {
                staticClass: "dropdown-menu menu-usuario portal-header-popover",
              },
              [
                _c("li", { staticClass: "menu-usuario__cabecera" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "avatar-usuario avatar-usuario--grande portal-header-action",
                    },
                    [_vm._v(" " + _vm._s(_vm.iniciales) + " ")]
                  ),
                  _c("div", { staticClass: "menu-usuario__identidad" }, [
                    _c("h6", { staticClass: "menu-usuario__titulo" }, [
                      _vm._v("Mi cuenta"),
                    ]),
                    _vm.usuario
                      ? _c("span", { staticClass: "menu-usuario__nombre" }, [
                          _vm._v(" " + _vm._s(_vm.usuario.user) + " "),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("li", { staticClass: "px-2" }, [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item hand",
                      on: { click: _vm.cambiarPassword },
                    },
                    [
                      _c("i", { staticClass: "fa fa-key" }),
                      _vm._v(" Cambiar contraseña "),
                    ]
                  ),
                ]),
                _c("li", { staticClass: "px-2 pb-2" }, [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item hand",
                      on: { click: _vm.cerrarSesion },
                    },
                    [
                      _c("i", { staticClass: "fa fa-sign-out" }),
                      _vm._v(" Cerrar sesión "),
                    ]
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm.showChangePassword
          ? _c("changePassword", {
              on: {
                hide: function ($event) {
                  _vm.showChangePassword = !_vm.showChangePassword
                },
                guardado: _vm.cambiarPassword,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "navbar-brand col-auto ps-0" }, [
      _c("div", { attrs: { id: "navbar-breadcrumb" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }